import Breadcrumb from 'src/components/Breadcrumb';
import { PATHS } from 'src/common/constants';

interface SuiteBreadcrumbProps {
  serviceRequestId: string | null;
  isFromDashboard: boolean;
  userRole: string;
  currentLocation: {
    state?: any;
  };
  showHomeownerDashboardNavigation: boolean;
  suiteIdParts: string[];
  property: any;
}

const SuiteBreadcrumb = ({
  serviceRequestId,
  isFromDashboard,
  userRole,
  currentLocation,
  showHomeownerDashboardNavigation,
  suiteIdParts,
  property,
}: SuiteBreadcrumbProps) => {
  // Service Request breadcrumb.
  if (serviceRequestId) {
    return (
      <Breadcrumb
        to={PATHS.SERVICE_REQUESTS_VIEW.replace(':id', serviceRequestId)}
        label="Service Request"
      />
    );
  }

  // Home Owner or Realtor breadcrumb.
  if (isFromDashboard || userRole === 'Home Owner' || userRole === 'Realtor') {
    const hasNavigateTo = currentLocation.state?.navigateTo;

    if (hasNavigateTo) {
      return (
        <Breadcrumb to={currentLocation.state!.navigateTo!} label="Inbox" />
      );
    }

    if (showHomeownerDashboardNavigation) {
      return <Breadcrumb to={PATHS.DASHBOARD} label="Dashboard" />;
    }

    return null;
  }

  // Default property breadcrumb.
  return (
    <Breadcrumb
      to={
        currentLocation.state?.navigateTo || {
          pathname: PATHS.PROPERTIES_VIEW.replace(':id', suiteIdParts[0]),
        }
      }
      label={property.name}
    />
  );
};

export default SuiteBreadcrumb;
